import { render, staticRenderFns } from "./edit-support.component.html?vue&type=template&id=50ecb93d&scoped=true&"
import script from "./edit-support.component.ts?vue&type=script&lang=ts&"
export * from "./edit-support.component.ts?vue&type=script&lang=ts&"
import style0 from "./edit-support.component.scss?vue&type=style&index=0&id=50ecb93d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ecb93d",
  null
  
)

export default component.exports